import { InstallmentInfo } from '../context/BatchPaymentContext';
import { apiLambda } from './apiLambda';

interface IData {
  name: string;
  cnpj?: string;
  cpf?: string;
  pix: InstallmentInfo;
  cupom: string;
  email: string;
  phone: string;
  consultCode: number;
  sub: string;
  debitos?: any;
  // consult: any;
}

export default async function generatePixForBatchs(data: IData) {
  try {
    const {
      name,
      cnpj,
      cpf,
      pix,
      cupom,
      email,
      phone,
      debitos,
      consultCode,
      sub,
    } = data;

    const debts: { codigo: number; valor: number }[] = [
      {
        codigo: debitos[0].codigo,
        valor: debitos[0].valor,
      },
    ];

    const body = {
      payloadCaptura: {
        parcelas: pix.month,
        valor: pix.totalPrice,
        cupom: cupom,
        debitos: debts,
        pix: [
          {
            pagador: {
              nome: name,
              cpf: cpf?.replace(/\D/g, ''),
              cnpj: cnpj?.replace(/\D/g, ''),
              email: email,
              telefone: phone.replace(/\D/g, ''),
            },
            valor: pix.totalPrice,
          },
        ],
        comportamento: {
          konduto: sub,
          clearsale: '',
          analytics: '',
        },
      },
    };

    const payment = await apiLambda.post(
      `comunix/payment/pix/${consultCode}`,
      body,
    );

    return payment.data.data;
  } catch (err: any) {
    console.log('GeneratePix ====> ', err.response);
    if (err.response?.data?.warning) {
      return { sucesso: false, warning: err.response.data.warning };
    }
    return { sucesso: false, data: err.response?.data?.data };
  }
}
